import React from 'react';
import RustikSettings from './settings/RustikSettings';
import TulKanatSettings from './settings/TulKanatSettings';
import JaluziSettings from './settings/JaluziSettings';
import StorZebraSettings from './settings/StorZebraSettings';
import DikeySettings from './settings/DikeySettings';
import KatlamaliSettings from './settings/KatlamaliSettings';

const ProductTypeSettings = React.memo(({
  activeTypeTab,
  isAdmin,
  isSatisci,
  handleSaveSettings,
  isSavingSettings,
  // Rustik Props
  rustikExtras,
  setRustikExtras,
  rustikStates,
  // Tul/Kanat Props
  tulExtraPrices,
  setTulExtraPrices,
  kanatExtraPrices,
  setKanatExtraPrices,
  // Jaluzi Props
  jaluziExtras,
  setJaluziExtras,
  metalJaluziExtras,
  setMetalJaluziExtras,
  // Stor/Zebra Props
  storExtras,
  setStorExtras,
  zebraExtras,
  setZebraExtras,
  // Dikey Props
  dikeyExtras,
  setDikeyExtras,
  dikeyPvcExtras,
  setDikeyPvcExtras,
  dikeyStorExtras,
  setDikeyStorExtras,
  // Katlamali Props
  katlamaliExtras,
  setKatlamaliExtras,
  katlamaliStates,
  // Dikey States
  dikeyStates
}) => {
  return (
    <div className="product-settings-container">
      {/* Rustik Ayarları */}
      {activeTypeTab === 'rustik' && (isAdmin || isSatisci) && (
        <RustikSettings
          rustikExtras={rustikExtras}
          setRustikExtras={setRustikExtras}
          {...rustikStates}
          handleSaveSettings={handleSaveSettings}
          isSavingSettings={isSavingSettings}
        />
      )}

      <div style={{ padding: '0 20px' }}>
        {/* Tül / Kanat Ayarları */}
        {(activeTypeTab === 'tul' || activeTypeTab === 'kanat') && (
          <TulKanatSettings
            extraPrices={activeTypeTab === 'tul' ? tulExtraPrices : kanatExtraPrices}
            setExtraPrices={activeTypeTab === 'tul' ? setTulExtraPrices : setKanatExtraPrices}
            handleSaveSettings={handleSaveSettings}
            isSavingSettings={isSavingSettings}
            activeTypeTab={activeTypeTab}
          />
        )}

        {/* Jaluzi Ayarları (Ahşap & Metal) */}
        {(activeTypeTab === 'ahsapJaluzi' || activeTypeTab === 'metalJaluzi') && (
          <JaluziSettings
            activeTypeTab={activeTypeTab}
            jaluziExtras={jaluziExtras}
            setJaluziExtras={setJaluziExtras}
            metalJaluziExtras={metalJaluziExtras}
            setMetalJaluziExtras={setMetalJaluziExtras}
            handleSaveSettings={handleSaveSettings}
            isSavingSettings={isSavingSettings}
          />
        )}

        {/* Stor / Zebra Ayarları */}
        {(activeTypeTab === 'stor' || activeTypeTab === 'zebra') && (
          <StorZebraSettings
            extraPrices={activeTypeTab === 'stor' ? storExtras : zebraExtras}
            setExtraPrices={activeTypeTab === 'stor' ? setStorExtras : setZebraExtras}
            activeTypeTab={activeTypeTab}
            handleSaveSettings={handleSaveSettings}
            isSavingSettings={isSavingSettings}
          />
        )}

        {/* Dikey Perde Ayarları */}
        {(activeTypeTab === 'dikeyPerde' || activeTypeTab === 'dikeyPvc' || activeTypeTab === 'dikeyStor') && (
          <DikeySettings
            activeTypeTab={activeTypeTab}
            dikeyExtras={dikeyExtras}
            setDikeyExtras={setDikeyExtras}
            dikeyPvcExtras={dikeyPvcExtras}
            setDikeyPvcExtras={setDikeyPvcExtras}
            dikeyStorExtras={dikeyStorExtras}
            setDikeyStorExtras={setDikeyStorExtras}
            {...dikeyStates}
            handleSaveSettings={handleSaveSettings}
            isSavingSettings={isSavingSettings}
          />
        )}

        {/* Katlamalı Perde Ayarları */}
        {activeTypeTab === 'katlamaliPerde' && (
          <KatlamaliSettings
            katlamaliExtras={katlamaliExtras}
            setKatlamaliExtras={setKatlamaliExtras}
            {...katlamaliStates}
            handleSaveSettings={handleSaveSettings}
            isSavingSettings={isSavingSettings}
          />
        )}
      </div>
    </div>
  );
});

export default ProductTypeSettings;
